import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ClienteService, DataService, AuthenticationService, ValidationService, EmpresaService } from '../../../services/service.index';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-datos-facturacion',
  templateUrl: './datos-facturacion.component.html',
  styleUrls: ['./datos-facturacion.component.css']
})
export class DatosFacturacionComponent implements OnInit {
  frmEmpresa: any;
  usosCfdi: [];
  usuario: any;
  catRegimen: any;
  constructor(
    private formBuilder: FormBuilder,
    private _activateRouter: ActivatedRoute,
    private _route: Router,
    private _clienteService: ClienteService,
    private _dataService: DataService,
    private _authService: AuthenticationService,
    private _empresaService: EmpresaService) { }

  ngOnInit() {
    this.usuario = this._authService.getUser();
    this.frmEmpresa = this.crearFormulario();
    //this.getUsosCfdi();
    console.log(this.usuario)
    this.getRegimenFiscal();
    this._activateRouter.params.subscribe(param => {
      //if (param['id'] != 'nuevo') {
        //Obtener el cliente
        Swal.showLoading();
        this._empresaService.getEmpresa(this.usuario.empresaId).subscribe((data: any) => {
          console.log(data)
          /*this.usosCfdi.forEach(function (item: any) {
            if (item.codigoUsoCfdi === data.usoCfdi) {
              data.usoCfdi = item.id;
            }
          });*/
          this.frmEmpresa.patchValue(data);
          Swal.hideLoading();
          Swal.close();
        })
      //}
    });
  }
  getRegimenFiscal() {
    this._dataService.getRegimenFiscal().subscribe(res=>this.catRegimen=res);
  }
  cambiarUsoCfdi(data) {

    this.usosCfdi.forEach(function (item: any) {
      if (item.codigoUsoCfdi === data) {

      }
    });
  }
  crearFormulario() {
    return this.formBuilder.group({
      nombreComercial:[],
      razonSocial: [],
      rfc: ['', ValidationService.rfcValidator],
      regimenFiscal:['',ValidationService.validRegimen],
      claveRegimen:[],
      calle: [''],
      numInterior: [null],
      numExterior: [null],
      colonia: [null],
      codigoPostal: [null],
      localidad: [null],
      municipio: [null],
      estado: [null],      
      pais: [null],
      telefono: [null, ValidationService.numberValidator],
      correo: [null, ValidationService.emailValidator],
      retieneImpuestos: ['0'],
      logotipo:[],
      iva: ['0.16'],
      sendMail: ['1'],
      id: [null]
    });
  }

  onSubmit() {
    console.log(this.frmEmpresa.value);
    //hacer calculo si aplica iva o no
    Swal.fire({
      title: 'Procesando ...',
      showLoaderOnConfirm: true,
      onOpen: (data) => {
        // console.log('Al abrir modal...');
        Swal.showLoading();
        this._empresaService.almacenar(this.frmEmpresa.value)
          .subscribe((resp: any) => {
            if (!resp.response) {
              let msj = '';
              if (resp.errors) {
                for (let item of resp.errors) {
                  msj += `<br>${item}`;
                }
              }
              Swal.showValidationMessage(
                `<div class="alert alert-danger" role="alert">Error en el proceso: ${msj}</div>`
              );
            }
            Swal.hideLoading();
            Swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'Guardado correctamente',
              showConfirmButton: false,
              timer: 1500
            });
            //this.reset();
            return resp;
          },
            (err: any) => {
              Swal.hideLoading();
              Swal.close();
              Swal.showValidationMessage(
                `Error en el proceso: ${err}`
              )
            });
      },
      allowOutsideClick: () => !Swal.isLoading()
    });

  }
  reset() {
    this.frmEmpresa.reset();
    this.frmEmpresa = this.crearFormulario();
    //this.router.navigate(['/productos']);
  }
}
